import { put, takeLatest } from 'redux-saga/effects';

import PropertyService from 'services/property.service';

import {
    addPropertyAdminRoutine,
    archivePropertyAdminRoutine,
    closeBiddingRoutine,
    getPropertiesRoutine,
    getPropertiesAdminRoutine,
    openBiddingRoutine,
    undoArchivePropertyRoutine
} from 'state/properties/properties.routines';

import { baseEffectHandler } from 'util/sagas';

export default function* propertiesSaga() {
    yield takeLatest(getPropertiesRoutine.TRIGGER, () =>
        baseEffectHandler({
            service: PropertyService.getAll,
            *onResponse(response) {
                yield put(getPropertiesRoutine.success(response));
            },
            *onError() {
                yield put(getPropertiesRoutine.failure());
            }
        })
    );

    yield takeLatest(getPropertiesAdminRoutine.TRIGGER, () =>
        baseEffectHandler({
            service: PropertyService.getAllAdmin,
            *onResponse(response) {
                yield put(getPropertiesRoutine.success(response));
            },
            *onError() {
                yield put(getPropertiesRoutine.failure());
            }
        })
    );

    yield takeLatest(addPropertyAdminRoutine.TRIGGER, (action) =>
        baseEffectHandler({
            service: PropertyService.addAdmin,
            data: action.payload,
            *onResponse() {
                const { onSuccess } = action.payload;
                if (onSuccess) yield onSuccess();
            },
            *onError() {
                yield put(addPropertyAdminRoutine.failure());
            }
        })
    );

    yield takeLatest(archivePropertyAdminRoutine.TRIGGER, (action) =>
        baseEffectHandler({
            service: PropertyService.archiveAdmin,
            data: action.payload,
            *onResponse(response) {
                const { onSuccess } = action.payload;
                yield put(archivePropertyAdminRoutine.success(response.data));
                yield put(getPropertiesRoutine.trigger());
                if (onSuccess) yield onSuccess();
            },
            *onError() {
                yield put(archivePropertyAdminRoutine.failure());
            }
        })
    );

    yield takeLatest(undoArchivePropertyRoutine.TRIGGER, (action) =>
        baseEffectHandler({
            service: PropertyService.undoArchiveAdmin,
            data: action.payload,
            *onResponse() {
                const { onSuccess } = action.payload;
                yield put(undoArchivePropertyRoutine.success());
                yield put(getPropertiesRoutine.trigger());
                if (onSuccess) yield onSuccess();
            },
            *onError() {
                yield put(undoArchivePropertyRoutine.failure());
            }
        })
    );

    yield takeLatest(closeBiddingRoutine.TRIGGER, (action) =>
        baseEffectHandler({
            service: PropertyService.closeBidding,
            data: action.payload,
            *onResponse() {
                const { onSuccess } = action.payload;
                yield put(closeBiddingRoutine.success());
                yield put(getPropertiesAdminRoutine.trigger());
                if (onSuccess) yield onSuccess();
            },
            *onError() {
                yield put(closeBiddingRoutine.failure());
            }
        })
    );

    yield takeLatest(openBiddingRoutine.TRIGGER, (action) =>
        baseEffectHandler({
            service: PropertyService.openBidding,
            data: action.payload,
            *onResponse() {
                const { onSuccess } = action.payload;
                yield put(openBiddingRoutine.success());
                yield put(getPropertiesAdminRoutine.trigger());
                if (onSuccess) yield onSuccess();
            },
            *onError() {
                yield put(openBiddingRoutine.failure());
            }
        })
    );
}
